<template>
  <div class="like-heart">
    <span class="heart-animate">💗</span>
  </div>
</template>
<script>
export default {
  name: 'like-animate'
}
</script>
<style lang="scss">
  .like-heart {
    position: absolute;
    top: 2px;
    right: 40px;
    font-size: 22px;
  }
  .heart-animate {
    position: absolute;
    right: 0;
    animation: like 0.8s forwards;
  }
  @keyframes like {
    0% {
      opacity: 1;
      top: 10px;
      display: block;
    }
    100% {
      opacity: 0;
      top: 0;
      transform: translateY(-15px);
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/likeAnimate.vue